(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var clamp = sbbNamespace.clamp;
  var parseNumber = sbbNamespace.parseNumber;
  var MAX_DISTANCE_OFFSET_MM = sbbNamespace.maxDistanceOffsetMm;
  var MAX_TAG_ID = sbbNamespace.maxTagId;
  var MM_PER_CM = sbbNamespace.mmPerCm;
  var USED_TAGS_STORAGE_KEY = sbbNamespace.usedTagsStorageKey;
  var IGNORED_TAGS_STORAGE_KEY = sbbNamespace.ignoredTagsStorageKey;
  var DEFAULT_NOISE_GRAIN_MM = sbbNamespace.defaultNoiseGrainMm;
  var DEFAULT_NOISE_CONTRAST = sbbNamespace.defaultNoiseContrast;
  var DEFAULT_NOISE_COLOR_A = sbbNamespace.defaultNoiseColorA;
  var DEFAULT_NOISE_COLOR_B = sbbNamespace.defaultNoiseColorB;
  var COMMAND_UNIT_OPTIONS = sbbNamespace.commandUnitOptions;
  if (!ScaleBarBuilder || !clamp || !parseNumber || !MAX_DISTANCE_OFFSET_MM || !MAX_TAG_ID || !MM_PER_CM || !USED_TAGS_STORAGE_KEY || !IGNORED_TAGS_STORAGE_KEY || !DEFAULT_NOISE_GRAIN_MM || !DEFAULT_NOISE_CONTRAST || !DEFAULT_NOISE_COLOR_A || !DEFAULT_NOISE_COLOR_B || !COMMAND_UNIT_OPTIONS) {
    return;
  }

ScaleBarBuilder.prototype.getActiveTags = function () {
    return this.state.tags.slice(0, this.state.tagCount);
  };

  ScaleBarBuilder.prototype.getCurrentPoints = function () {
    var tags = this.getActiveTags();
    return tags.map(function (tag) {
      return { x: tag.xMm, y: tag.yMm };
    });
  };

  ScaleBarBuilder.prototype.getDistanceEdgeKey = function (aIndex, bIndex) {
    var a = Math.min(aIndex, bIndex);
    var b = Math.max(aIndex, bIndex);
    return String(a) + '-' + String(b);
  };

  ScaleBarBuilder.prototype.parseDistanceEdgeKey = function (key) {
    var parts = String(key || '').split('-');
    if (parts.length !== 2) {
      return null;
    }
    var a = parseInt(parts[0], 10);
    var b = parseInt(parts[1], 10);
    if (!Number.isFinite(a) || !Number.isFinite(b) || a < 0 || b < 0 || a === b) {
      return null;
    }
    return {
      a: Math.min(a, b),
      b: Math.max(a, b)
    };
  };

  ScaleBarBuilder.prototype.getDistanceEdges = function (tags) {
    var activeTags = tags || this.getActiveTags();
    var n = activeTags.length;
    if (n < 2) {
      return [];
    }
    if (n === 2) {
      return [{ a: 0, b: 1, key: this.getDistanceEdgeKey(0, 1) }];
    }

    var edges = [];
    var visited = {};
    var visitedCount = 0;
    var home = this.getHomePoint();
    var startIndex = 0;
    var bestHomeDist = Infinity;
    for (var s = 0; s < n; s += 1) {
      var hdx = activeTags[s].xMm - home.xMm;
      var hdy = activeTags[s].yMm - home.yMm;
      var hd2 = hdx * hdx + hdy * hdy;
      if (hd2 < bestHomeDist) {
        bestHomeDist = hd2;
        startIndex = s;
      }
    }
    visited[startIndex] = true;
    visitedCount += 1;

    while (visitedCount < n) {
      var best = null;
      var i;
      var j;
      for (i = 0; i < n; i += 1) {
        if (!visited[i]) {
          continue;
        }
        for (j = 0; j < n; j += 1) {
          if (visited[j]) {
            continue;
          }
          var dx = activeTags[j].xMm - activeTags[i].xMm;
          var dy = activeTags[j].yMm - activeTags[i].yMm;
          var d2 = dx * dx + dy * dy;
          if (!best || d2 < best.d2 - 0.00001 || (Math.abs(d2 - best.d2) < 0.00001 && (j < best.b || (j === best.b && i < best.a)))) {
            best = {
              a: i,
              b: j,
              d2: d2
            };
          }
        }
      }

      if (!best) {
        break;
      }
      visited[best.b] = true;
      visitedCount += 1;
      edges.push({
        a: best.a,
        b: best.b,
        key: this.getDistanceEdgeKey(best.a, best.b)
      });
    }

    return edges;
  };

  ScaleBarBuilder.prototype.ensureDistanceAnnotations = function (edges) {
    if (!this.state.distanceAnnotations || typeof this.state.distanceAnnotations !== 'object') {
      this.state.distanceAnnotations = {};
    }

    var nextMap = {};
    for (var i = 0; i < edges.length; i += 1) {
      var key = edges[i].key;
      var previous = this.state.distanceAnnotations[key] || {};
      nextMap[key] = {
        t: clamp(parseNumber(previous.t, 0.5), 0, 1),
        normalOffsetMm: clamp(parseNumber(previous.normalOffsetMm, 0), -MAX_DISTANCE_OFFSET_MM, MAX_DISTANCE_OFFSET_MM),
        hidden: !!previous.hidden
      };
    }
    this.state.distanceAnnotations = nextMap;
  };

  ScaleBarBuilder.prototype.getDistanceAnnotation = function (edgeKey) {
    if (!this.state.distanceAnnotations || !this.state.distanceAnnotations[edgeKey]) {
      return {
        t: 0.5,
        normalOffsetMm: 0,
        hidden: false
      };
    }
    var item = this.state.distanceAnnotations[edgeKey];
    return {
      t: clamp(parseNumber(item.t, 0.5), 0, 1),
      normalOffsetMm: clamp(parseNumber(item.normalOffsetMm, 0), -MAX_DISTANCE_OFFSET_MM, MAX_DISTANCE_OFFSET_MM),
      hidden: !!item.hidden
    };
  };

  ScaleBarBuilder.prototype.getOriginTag = function () {
    var home = this.getHomePoint();
    if (!home) {
      return null;
    }
    return {
      id: 'home',
      xMm: home.xMm,
      yMm: home.yMm
    };
  };

  ScaleBarBuilder.prototype.formatSignedDistanceMm = function (distanceMm) {
    var sign = distanceMm >= 0 ? '+' : '-';
    var value = this.formatCoordinate(Math.abs(distanceMm), this.state.unitSystem, { minDp: 4, maxDp: 8 });
    var unit = this.state.unitSystem === 'imperial' ? 'in' : 'mm';
    return sign + value + unit;
  };

  ScaleBarBuilder.prototype.formatSignedDistanceValueMm = function (distanceMm) {
    var sign = distanceMm >= 0 ? '+' : '-';
    var value = this.formatCoordinate(Math.abs(distanceMm), this.state.unitSystem, { minDp: 4, maxDp: 8 });
    return sign + value;
  };

  ScaleBarBuilder.prototype.getRelativeCoordinateText = function (xMm, yMm) {
    var homePoint = this.getHomePoint();
    if (!homePoint) {
      return '';
    }
    var dx = parseNumber(xMm, homePoint.xMm) - homePoint.xMm;
    var dy = homePoint.yMm - parseNumber(yMm, homePoint.yMm);
    return 'x:' + this.formatSignedDistanceValueMm(dx) + ' y:' + this.formatSignedDistanceValueMm(dy) + ' z:+0';
  };

  ScaleBarBuilder.prototype.isCircularShapeKind = function (shapeKind) {
    return shapeKind === 'circle' || shapeKind === 'circle-quartered' || shapeKind === 'circle-grid';
  };

  ScaleBarBuilder.prototype.sanitizeCommandUnitMode = function (mode) {
    var value = String(mode || '').trim();
    for (var i = 0; i < COMMAND_UNIT_OPTIONS.length; i += 1) {
      if (COMMAND_UNIT_OPTIONS[i].value === value) {
        return value;
      }
    }
    return 'meter';
  };

  ScaleBarBuilder.prototype.sanitizeRealityScanOutputMode = function (mode) {
    return String(mode || '').trim() === 'distance' ? 'distance' : 'ground';
  };

  ScaleBarBuilder.prototype.getCurrentTagScopeKey = function () {
    return String(this.state.tagType || 'apriltag') + '|' + String(this.state.tagFamily || '');
  };

  ScaleBarBuilder.prototype.sanitizeUsedTagRegistryPayload = function (payload) {
    var src = payload && typeof payload === 'object' ? payload : {};
    var out = {};
    var scopes = Object.keys(src);
    for (var i = 0; i < scopes.length; i += 1) {
      var scope = scopes[i];
      var entries = Array.isArray(src[scope]) ? src[scope] : [];
      var cleaned = [];
      for (var j = 0; j < entries.length; j += 1) {
        var row = entries[j];
        if (!row || typeof row !== 'object') {
          continue;
        }
        var id = clamp(Math.round(parseNumber(row.id, NaN)), 0, MAX_TAG_ID);
        if (!Number.isFinite(id)) {
          continue;
        }
        cleaned.push({
          id: id,
          displayCode: String(row.displayCode || row.code || id),
          xMm: parseNumber(row.xMm, 0),
          yMm: parseNumber(row.yMm, 0),
          zMm: parseNumber(row.zMm, 0)
        });
      }
      cleaned.sort(function (a, b) { return a.id - b.id; });
      out[scope] = cleaned;
    }
    return out;
  };

  ScaleBarBuilder.prototype.sanitizeIgnoredTagRegistryPayload = function (payload) {
    var src = payload && typeof payload === 'object' ? payload : {};
    var out = {};
    var scopes = Object.keys(src);
    for (var i = 0; i < scopes.length; i += 1) {
      var scope = scopes[i];
      var values = Array.isArray(src[scope]) ? src[scope] : [];
      var map = {};
      for (var j = 0; j < values.length; j += 1) {
        var id = clamp(Math.round(parseNumber(values[j], NaN)), 0, MAX_TAG_ID);
        if (Number.isFinite(id)) {
          map[id] = true;
        }
      }
      out[scope] = Object.keys(map).map(function (k) { return parseInt(k, 10); }).sort(function (a, b) { return a - b; });
    }
    return out;
  };

  ScaleBarBuilder.prototype.loadTagRegistriesFromLocal = function () {
    try {
      var usedRaw = localStorage.getItem(USED_TAGS_STORAGE_KEY);
      this.usedTagRegistryByScope = usedRaw ? this.sanitizeUsedTagRegistryPayload(parseJsonObject(usedRaw)) : {};
    } catch (error) {
      this.usedTagRegistryByScope = {};
    }
    try {
      var ignoredRaw = localStorage.getItem(IGNORED_TAGS_STORAGE_KEY);
      this.ignoredTagIdRegistryByScope = ignoredRaw ? this.sanitizeIgnoredTagRegistryPayload(parseJsonObject(ignoredRaw)) : {};
    } catch (error2) {
      this.ignoredTagIdRegistryByScope = {};
    }
  };

  ScaleBarBuilder.prototype.saveTagRegistriesToLocal = function () {
    try {
      localStorage.setItem(USED_TAGS_STORAGE_KEY, JSON.stringify(this.usedTagRegistryByScope || {}));
      localStorage.setItem(IGNORED_TAGS_STORAGE_KEY, JSON.stringify(this.ignoredTagIdRegistryByScope || {}));
      return true;
    } catch (error) {
      return false;
    }
  };

  ScaleBarBuilder.prototype.getUsedTagRowsForCurrentScope = function () {
    var scope = this.getCurrentTagScopeKey();
    return Array.isArray(this.usedTagRegistryByScope[scope]) ? this.usedTagRegistryByScope[scope].slice() : [];
  };

  ScaleBarBuilder.prototype.getReservedTagIdMapForCurrentScope = function () {
    var scope = this.getCurrentTagScopeKey();
    var reserved = {};
    var usedRows = Array.isArray(this.usedTagRegistryByScope[scope]) ? this.usedTagRegistryByScope[scope] : [];
    var ignored = Array.isArray(this.ignoredTagIdRegistryByScope[scope]) ? this.ignoredTagIdRegistryByScope[scope] : [];
    for (var i = 0; i < usedRows.length; i += 1) {
      reserved[usedRows[i].id] = true;
    }
    for (var j = 0; j < ignored.length; j += 1) {
      reserved[ignored[j]] = true;
    }
    return reserved;
  };

  ScaleBarBuilder.prototype.parseTagIdFromCsvField = function (rawValue) {
    var text = String(rawValue || '').trim().replace(/^"|"$/g, '');
    if (!text) {
      return null;
    }
    var colonMatch = /:([0-9a-f]+)$/i.exec(text);
    if (colonMatch) {
      return clamp(parseInt(colonMatch[1], 16), 0, MAX_TAG_ID);
    }
    var idMatch = /^id\s*([0-9]+)$/i.exec(text);
    if (idMatch) {
      return clamp(parseInt(idMatch[1], 10), 0, MAX_TAG_ID);
    }
    if (/^[0-9]+$/.test(text)) {
      return clamp(parseInt(text, 10), 0, MAX_TAG_ID);
    }
    if (/^[0-9a-f]+$/i.test(text)) {
      return clamp(parseInt(text, 16), 0, MAX_TAG_ID);
    }
    var firstNumber = /([0-9]+)/.exec(text);
    if (firstNumber) {
      return clamp(parseInt(firstNumber[1], 10), 0, MAX_TAG_ID);
    }
    return null;
  };

  ScaleBarBuilder.prototype.recordCurrentTagsAsUsed = function (tags) {
    var active = Array.isArray(tags) ? tags : this.getActiveTags();
    var rows = this.getScaleBarCoordinateRows(active);
    if (!rows.length) {
      return false;
    }
    var scope = this.getCurrentTagScopeKey();
    var existing = Array.isArray(this.usedTagRegistryByScope[scope]) ? this.usedTagRegistryByScope[scope].slice() : [];
    var byId = {};
    for (var i = 0; i < existing.length; i += 1) {
      byId[existing[i].id] = existing[i];
    }
    for (var j = 0; j < rows.length; j += 1) {
      var row = rows[j];
      byId[row.id] = {
        id: row.id,
        displayCode: row.displayCode,
        xMm: row.xMm,
        yMm: row.yMm,
        zMm: row.zMm
      };
    }
    var merged = Object.keys(byId).map(function (key) {
      return byId[key];
    }).sort(function (a, b) {
      return a.id - b.id;
    });
    this.usedTagRegistryByScope[scope] = merged;
    this.saveTagRegistriesToLocal();
    return true;
  };

  ScaleBarBuilder.prototype.importIgnoredTagsCsv = function (file) {
    var self = this;
    if (!file) {
      return;
    }
    var reader = new FileReader();
    reader.onload = function () {
      var scope = self.getCurrentTagScopeKey();
      var existing = Array.isArray(self.ignoredTagIdRegistryByScope[scope]) ? self.ignoredTagIdRegistryByScope[scope].slice() : [];
      var map = {};
      for (var i = 0; i < existing.length; i += 1) {
        map[existing[i]] = true;
      }
      var text = String(reader.result || '');
      var lines = text.split(/\r?\n/);
      var added = 0;
      for (var li = 0; li < lines.length; li += 1) {
        var line = lines[li].trim();
        if (!line || /^tag id/i.test(line)) {
          continue;
        }
        var cols = line.split(',');
        var parsed = self.parseTagIdFromCsvField(cols[0]);
        if (parsed === null || !Number.isFinite(parsed)) {
          continue;
        }
        if (!map[parsed]) {
          map[parsed] = true;
          added += 1;
        }
      }
      var next = Object.keys(map).map(function (k) { return parseInt(k, 10); }).sort(function (a, b) { return a - b; });
      self.ignoredTagIdRegistryByScope[scope] = next;
      self.saveTagRegistriesToLocal();
      self.resolveUniqueViableTagIds();
      self.syncDynamicRows();
      self.refreshUsedTagCsvDisplay();
      self.render();
      self.commitHistory();
      self.setStatus('Ignore CSV imported (' + added + ' IDs added).', false);
    };
    reader.onerror = function () {
      self.setStatus('Unable to read ignore CSV file.', true);
    };
    reader.readAsText(file);
  };

  ScaleBarBuilder.prototype.sanitizeBackgroundNoise = function (noise) {
    var src = noise && typeof noise === 'object' ? noise : {};
    return {
      enabled: !!src.enabled,
      grainSizeMm: clamp(parseNumber(src.grainSizeMm, DEFAULT_NOISE_GRAIN_MM), 0.2, 8),
      contrast: clamp(parseNumber(src.contrast, DEFAULT_NOISE_CONTRAST), 0, 1),
      colorA: typeof src.colorA === 'string' && src.colorA.trim() ? src.colorA : DEFAULT_NOISE_COLOR_A,
      colorB: typeof src.colorB === 'string' && src.colorB.trim() ? src.colorB : DEFAULT_NOISE_COLOR_B
    };
  };

  ScaleBarBuilder.prototype.uniqueSortedValues = function (values, toleranceMm) {
    var tolerance = toleranceMm || 0.1;
    var sorted = values.slice().sort(function (a, b) { return a - b; });
    var unique = [];

    for (var i = 0; i < sorted.length; i += 1) {
      if (unique.length === 0 || Math.abs(sorted[i] - unique[unique.length - 1]) > tolerance) {
        unique.push(sorted[i]);
      }
    }
    return unique;
  };

  ScaleBarBuilder.prototype.getCutRectangles = function (points, paper) {
    var rects = [];
    if (!Array.isArray(points)) {
      return rects;
    }
    var printable = this.getPrintableRect(paper, 0);
    for (var i = 0; i < points.length; i += 1) {
      var p = points[i];
      var sizeMm = this.getTagSizeMm(i);
      var padding = sizeMm / 2 + this.state.cutMarginCm * MM_PER_CM;
      var left = clamp(p.x - padding, printable.minX, printable.maxX);
      var right = clamp(p.x + padding, printable.minX, printable.maxX);
      var top = clamp(p.y - padding, printable.minY, printable.maxY);
      var bottom = clamp(p.y + padding, printable.minY, printable.maxY);
      if (right - left > 0.1 && bottom - top > 0.1) {
        rects.push({ left: left, right: right, top: top, bottom: bottom });
      }
    }
    return rects;
  };

  ScaleBarBuilder.prototype.getPolygonArea = function (vertices) {
    var area = 0;
    for (var i = 0; i < vertices.length; i += 1) {
      var a = vertices[i];
      var b = vertices[(i + 1) % vertices.length];
      area += a.x * b.y - b.x * a.y;
    }
    return area / 2;
  };

  ScaleBarBuilder.prototype.simplifyOrthogonalVertices = function (vertices) {
    if (!vertices || vertices.length < 3) {
      return vertices || [];
    }
    var out = [];
    for (var i = 0; i < vertices.length; i += 1) {
      var prev = vertices[(i - 1 + vertices.length) % vertices.length];
      var curr = vertices[i];
      var next = vertices[(i + 1) % vertices.length];
      var dx1 = curr.x - prev.x;
      var dy1 = curr.y - prev.y;
      var dx2 = next.x - curr.x;
      var dy2 = next.y - curr.y;
      if (Math.abs(dx1) < 0.0001 && Math.abs(dx2) < 0.0001) {
        continue;
      }
      if (Math.abs(dy1) < 0.0001 && Math.abs(dy2) < 0.0001) {
        continue;
      }
      out.push(curr);
    }
    return out;
  };

  ScaleBarBuilder.prototype.buildUnionOutlineFromRects = function (rects) {
    if (!rects.length) {
      return { vertices: [], loopCount: 0 };
    }
    var xs = [];
    var ys = [];
    for (var i = 0; i < rects.length; i += 1) {
      xs.push(rects[i].left, rects[i].right);
      ys.push(rects[i].top, rects[i].bottom);
    }
    xs = this.uniqueSortedValues(xs, 0.0001);
    ys = this.uniqueSortedValues(ys, 0.0001);
    if (xs.length < 2 || ys.length < 2) {
      return { vertices: [], loopCount: 0 };
    }

    var cols = xs.length - 1;
    var rows = ys.length - 1;
    var filled = [];
    for (var r = 0; r < rows; r += 1) {
      filled[r] = [];
      for (var c = 0; c < cols; c += 1) {
        var cx = (xs[c] + xs[c + 1]) / 2;
        var cy = (ys[r] + ys[r + 1]) / 2;
        var inside = false;
        for (var k = 0; k < rects.length; k += 1) {
          var rect = rects[k];
          if (cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom) {
            inside = true;
            break;
          }
        }
        filled[r][c] = inside;
      }
    }

    var segments = [];
    for (var y = 0; y < rows; y += 1) {
      for (var x = 0; x < cols; x += 1) {
        if (!filled[y][x]) {
          continue;
        }
        var x0 = xs[x];
        var x1 = xs[x + 1];
        var y0 = ys[y];
        var y1 = ys[y + 1];
        if (y === 0 || !filled[y - 1][x]) {
          segments.push({ x1: x0, y1: y0, x2: x1, y2: y0 });
        }
        if (x === cols - 1 || !filled[y][x + 1]) {
          segments.push({ x1: x1, y1: y0, x2: x1, y2: y1 });
        }
        if (y === rows - 1 || !filled[y + 1][x]) {
          segments.push({ x1: x1, y1: y1, x2: x0, y2: y1 });
        }
        if (x === 0 || !filled[y][x - 1]) {
          segments.push({ x1: x0, y1: y1, x2: x0, y2: y0 });
        }
      }
    }

    var byStart = {};
    for (var s = 0; s < segments.length; s += 1) {
      var key = segments[s].x1.toFixed(4) + ',' + segments[s].y1.toFixed(4);
      if (!byStart[key]) {
        byStart[key] = [];
      }
      byStart[key].push(s);
    }

    var used = {};
    var loops = [];
    for (var si = 0; si < segments.length; si += 1) {
      if (used[si]) {
        continue;
      }
      var loop = [];
      var current = si;
      var safety = 0;
      while (!used[current] && safety < 8000) {
        safety += 1;
        used[current] = true;
        var seg = segments[current];
        loop.push({ x: seg.x1, y: seg.y1 });
        var nextKey = seg.x2.toFixed(4) + ',' + seg.y2.toFixed(4);
        var nextList = byStart[nextKey];
        if (!nextList || nextList.length === 0) {
          break;
        }
        var found = -1;
        for (var ni = 0; ni < nextList.length; ni += 1) {
          if (!used[nextList[ni]]) {
            found = nextList[ni];
            break;
          }
        }
        if (found === -1) {
          break;
        }
        current = found;
      }
      if (loop.length >= 3) {
        loops.push(this.simplifyOrthogonalVertices(loop));
      }
    }

    if (!loops.length) {
      return { vertices: [], loopCount: 0 };
    }

    var best = loops[0];
    var bestArea = Math.abs(this.getPolygonArea(best));
    for (var li = 1; li < loops.length; li += 1) {
      var area = Math.abs(this.getPolygonArea(loops[li]));
      if (area > bestArea) {
        best = loops[li];
        bestArea = area;
      }
    }
    return {
      vertices: best,
      loopCount: loops.length
    };
  };

  ScaleBarBuilder.prototype.buildCutBridgeRects = function (points, paper) {
    var bridges = [];
    if (!Array.isArray(points) || points.length < 2) {
      return bridges;
    }
    var printable = this.getPrintableRect(paper, 0);
    var edges = this.getDistanceEdges(this.getActiveTags());
    if (!edges.length) {
      return bridges;
    }

    var cutMarginMm = this.state.cutMarginCm * MM_PER_CM;
    for (var i = 0; i < edges.length; i += 1) {
      var a = points[edges[i].a];
      var b = points[edges[i].b];
      if (!a || !b) {
        continue;
      }
      var padA = this.getTagSizeMm(edges[i].a) / 2 + cutMarginMm;
      var padB = this.getTagSizeMm(edges[i].b) / 2 + cutMarginMm;
      var bridgeHalf = Math.max(1, Math.min(padA, padB));

      var dx = b.x - a.x;
      var dy = b.y - a.y;
      var horizontalFirst = Math.abs(dx) >= Math.abs(dy);
      var corner = horizontalFirst ? { x: b.x, y: a.y } : { x: a.x, y: b.y };
      var segments = [
        { s: a, e: corner },
        { s: corner, e: b }
      ];

      for (var si = 0; si < segments.length; si += 1) {
        var s = segments[si].s;
        var e = segments[si].e;
        if (Math.abs(s.x - e.x) < 0.0001 && Math.abs(s.y - e.y) < 0.0001) {
          continue;
        }
        var left = Math.min(s.x, e.x) - bridgeHalf;
        var right = Math.max(s.x, e.x) + bridgeHalf;
        var top = Math.min(s.y, e.y) - bridgeHalf;
        var bottom = Math.max(s.y, e.y) + bridgeHalf;
        bridges.push({
          left: clamp(left, printable.minX, printable.maxX),
          right: clamp(right, printable.minX, printable.maxX),
          top: clamp(top, printable.minY, printable.maxY),
          bottom: clamp(bottom, printable.minY, printable.maxY)
        });
      }
    }
    return bridges;
  };

  ScaleBarBuilder.prototype.getVerticesBbox = function (vertices) {
    if (!vertices || !vertices.length) {
      return { xMm: 0, yMm: 0, wMm: 0, hMm: 0 };
    }
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for (var i = 0; i < vertices.length; i += 1) {
      minX = Math.min(minX, vertices[i].x);
      minY = Math.min(minY, vertices[i].y);
      maxX = Math.max(maxX, vertices[i].x);
      maxY = Math.max(maxY, vertices[i].y);
    }
    return { xMm: minX, yMm: minY, wMm: maxX - minX, hMm: maxY - minY };
  };

  ScaleBarBuilder.prototype.sanitizeCutInsets = function (insets) {
    var raw = insets || {};
    return {
      left: clamp(parseNumber(raw.left, 0), 0, 150),
      right: clamp(parseNumber(raw.right, 0), 0, 150),
      top: clamp(parseNumber(raw.top, 0), 0, 150),
      bottom: clamp(parseNumber(raw.bottom, 0), 0, 150)
    };
  };

  ScaleBarBuilder.prototype.sanitizeCutCircle = function (cutCircle) {
    var paper = this.getPaper();
    var raw = cutCircle && typeof cutCircle === 'object' ? cutCircle : {};
    var minDiameter = 5;
    var maxDiameter = Math.max(20, Math.min(paper.width, paper.height) * 1.8);
    return {
      centerXMm: clamp(parseNumber(raw.centerXMm, paper.width / 2), 0, paper.width),
      centerYMm: clamp(parseNumber(raw.centerYMm, paper.height / 2), 0, paper.height),
      diameterMm: clamp(parseNumber(raw.diameterMm, Math.min(paper.width, paper.height) * 0.8), minDiameter, maxDiameter),
      initialized: !!raw.initialized
    };
  };

  ScaleBarBuilder.prototype.sanitizeCutShapeMode = function (mode) {
    return (mode === 'rectangle' || mode === 'conform' || mode === 'angled' || mode === 'circle' || mode === 'manual') ? mode : 'conform';
  };

  ScaleBarBuilder.prototype.sanitizeCutManual = function (cutManual) {
    var paper = this.getPaper();
    var raw = cutManual && typeof cutManual === 'object' ? cutManual : {};
    var nodesIn = Array.isArray(raw.nodes) ? raw.nodes : [];
    var nodesOut = [];
    for (var i = 0; i < nodesIn.length; i += 1) {
      var node = nodesIn[i];
      if (!node || typeof node !== 'object') {
        continue;
      }
      var nx = clamp(parseNumber(node.x, paper.width / 2), 0, paper.width);
      var ny = clamp(parseNumber(node.y, paper.height / 2), 0, paper.height);
      var type = node.pointType === 'bezier' ? 'bezier' : 'corner';
      var inX = clamp(parseNumber(node.inX, nx), 0, paper.width);
      var inY = clamp(parseNumber(node.inY, ny), 0, paper.height);
      var outX = clamp(parseNumber(node.outX, nx), 0, paper.width);
      var outY = clamp(parseNumber(node.outY, ny), 0, paper.height);
      if (type !== 'bezier') {
        inX = nx;
        inY = ny;
        outX = nx;
        outY = ny;
      }
      nodesOut.push({
        x: nx,
        y: ny,
        inX: inX,
        inY: inY,
        outX: outX,
        outY: outY,
        pointType: type
      });
    }
    var selectedPointIndex = clamp(Math.round(parseNumber(raw.selectedPointIndex, -1)), -1, Math.max(-1, nodesOut.length - 1));
    var closed = !!raw.closed && nodesOut.length >= 3;
    return {
      tool: raw.tool === 'draw' ? 'draw' : 'edit',
      showGrid: raw.showGrid !== false,
      closed: closed,
      selectedPointIndex: selectedPointIndex,
      nodes: nodesOut
    };
  };

  ScaleBarBuilder.prototype.getCutManualState = function () {
    this.state.cutManual = this.sanitizeCutManual(this.state.cutManual);
    return this.state.cutManual;
  };

  ScaleBarBuilder.prototype.resetCutManual = function () {
    this.state.cutManual = {
      tool: 'edit',
      showGrid: true,
      closed: false,
      selectedPointIndex: -1,
      nodes: []
    };
    this.manualCutPreviewPointerMm = null;
    this.state.cutShape = {
      vertices: [],
      bbox: { xMm: 0, yMm: 0, wMm: 0, hMm: 0 }
    };
  };

  ScaleBarBuilder.prototype.isCutManualNodeBezier = function (node) {
    if (!node) {
      return false;
    }
    if (node.pointType === 'bezier') {
      return true;
    }
    var eps = 0.001;
    return Math.abs(parseNumber(node.inX, node.x) - node.x) > eps ||
      Math.abs(parseNumber(node.inY, node.y) - node.y) > eps ||
      Math.abs(parseNumber(node.outX, node.x) - node.x) > eps ||
      Math.abs(parseNumber(node.outY, node.y) - node.y) > eps;
  };

  ScaleBarBuilder.prototype.sampleCubicBezierPoint = function (p0, c1, c2, p1, t) {
    var mt = 1 - t;
    var mt2 = mt * mt;
    var t2 = t * t;
    return {
      x: (mt2 * mt * p0.x) + (3 * mt2 * t * c1.x) + (3 * mt * t2 * c2.x) + (t2 * t * p1.x),
      y: (mt2 * mt * p0.y) + (3 * mt2 * t * c1.y) + (3 * mt * t2 * c2.y) + (t2 * t * p1.y)
    };
  };

  ScaleBarBuilder.prototype.buildCutManualVertices = function (manual) {
    var state = manual || this.getCutManualState();
    if (!state || !state.closed || !Array.isArray(state.nodes) || state.nodes.length < 3) {
      return [];
    }
    var nodes = state.nodes;
    var out = [];
    for (var i = 0; i < nodes.length; i += 1) {
      var a = nodes[i];
      var b = nodes[(i + 1) % nodes.length];
      if (i === 0) {
        out.push({ x: a.x, y: a.y });
      }
      var c1 = { x: parseNumber(a.outX, a.x), y: parseNumber(a.outY, a.y) };
      var c2 = { x: parseNumber(b.inX, b.x), y: parseNumber(b.inY, b.y) };
      var curved = this.isCutManualNodeBezier(a) || this.isCutManualNodeBezier(b);
      if (!curved) {
        out.push({ x: b.x, y: b.y });
        continue;
      }
      var segLength = Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
      var steps = clamp(Math.round(segLength / 4), 8, 28);
      for (var s = 1; s <= steps; s += 1) {
        out.push(this.sampleCubicBezierPoint(a, c1, c2, b, s / steps));
      }
    }
    if (out.length >= 3 && this.getPolygonArea(out) > 0) {
      out.reverse();
    }
    return out;
  };

  ScaleBarBuilder.prototype.convertCutManualPointToStraight = function (index) {
    var manual = this.getCutManualState();
    if (!manual || !Array.isArray(manual.nodes) || !manual.nodes.length) {
      return false;
    }
    var idx = Math.round(parseNumber(index, -1));
    if (idx < 0 || idx >= manual.nodes.length) {
      return false;
    }
    var node = manual.nodes[idx];
    if (!node) {
      return false;
    }
    node.inX = node.x;
    node.inY = node.y;
    node.outX = node.x;
    node.outY = node.y;
    node.pointType = 'corner';
    manual.selectedPointIndex = idx;
    this.state.cutManual = manual;
    return true;
  };

  ScaleBarBuilder.prototype.convertCutManualPointToBezier = function (index) {
    var manual = this.getCutManualState();
    if (!manual || !Array.isArray(manual.nodes) || !manual.nodes.length) {
      return false;
    }
    var idx = Math.round(parseNumber(index, -1));
    if (idx < 0 || idx >= manual.nodes.length) {
      return false;
    }
    var node = manual.nodes[idx];
    if (!node) {
      return false;
    }
    var prev = manual.nodes[idx - 1] || (manual.closed ? manual.nodes[manual.nodes.length - 1] : null);
    var next = manual.nodes[idx + 1] || (manual.closed ? manual.nodes[0] : null);
    var vx = 1;
    var vy = 0;
    if (prev && next) {
      vx = next.x - prev.x;
      vy = next.y - prev.y;
    } else if (next) {
      vx = next.x - node.x;
      vy = next.y - node.y;
    } else if (prev) {
      vx = node.x - prev.x;
      vy = node.y - prev.y;
    }
    var len = Math.sqrt(vx * vx + vy * vy);
    if (len < 0.001) {
      len = 1;
    }
    var ux = vx / len;
    var uy = vy / len;
    var handleLen = Math.max(1.5, Math.min(8, this.getGridStepMm() * 0.8));
    var paper = this.getPaper();
    node.outX = clamp(node.x + ux * handleLen, 0, paper.width);
    node.outY = clamp(node.y + uy * handleLen, 0, paper.height);
    node.inX = clamp(node.x - ux * handleLen, 0, paper.width);
    node.inY = clamp(node.y - uy * handleLen, 0, paper.height);
    node.pointType = 'bezier';
    manual.selectedPointIndex = idx;
    this.state.cutManual = manual;
    return true;
  };

  ScaleBarBuilder.prototype.getBoundingRectVerticesFromRects = function (rects, paper) {
    var list = Array.isArray(rects) ? rects : [];
    if (!list.length) {
      var printable = this.getPrintableRect(paper, 0);
      return [
        { x: printable.minX, y: printable.minY },
        { x: printable.maxX, y: printable.minY },
        { x: printable.maxX, y: printable.maxY },
        { x: printable.minX, y: printable.maxY }
      ];
    }
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for (var i = 0; i < list.length; i += 1) {
      minX = Math.min(minX, list[i].left);
      minY = Math.min(minY, list[i].top);
      maxX = Math.max(maxX, list[i].right);
      maxY = Math.max(maxY, list[i].bottom);
    }
    return [
      { x: minX, y: minY },
      { x: maxX, y: minY },
      { x: maxX, y: maxY },
      { x: minX, y: maxY }
    ];
  };

  ScaleBarBuilder.prototype.getConcaveVertexCount = function (vertices) {
    if (!vertices || vertices.length < 4) {
      return 0;
    }
    var area = this.getPolygonArea(vertices);
    if (Math.abs(area) < 0.0001) {
      return 0;
    }
    var windingSign = area > 0 ? 1 : -1;
    var concaveCount = 0;
    for (var i = 0; i < vertices.length; i += 1) {
      var prev = vertices[(i - 1 + vertices.length) % vertices.length];
      var curr = vertices[i];
      var next = vertices[(i + 1) % vertices.length];
      var v1x = curr.x - prev.x;
      var v1y = curr.y - prev.y;
      var v2x = next.x - curr.x;
      var v2y = next.y - curr.y;
      var cross = v1x * v2y - v1y * v2x;
      if (Math.abs(cross) < 0.0001) {
        continue;
      }
      if (cross * windingSign < 0) {
        concaveCount += 1;
      }
    }
    return concaveCount;
  };

  ScaleBarBuilder.prototype.getConvexHullVertices = function (vertices) {
    if (!Array.isArray(vertices) || vertices.length < 3) {
      return vertices || [];
    }
    var seen = {};
    var pts = [];
    for (var i = 0; i < vertices.length; i += 1) {
      var p = vertices[i];
      var key = p.x.toFixed(4) + ',' + p.y.toFixed(4);
      if (seen[key]) {
        continue;
      }
      seen[key] = true;
      pts.push({ x: p.x, y: p.y });
    }
    if (pts.length < 3) {
      return pts;
    }
    pts.sort(function (a, b) {
      if (a.x !== b.x) {
        return a.x - b.x;
      }
      return a.y - b.y;
    });
    var cross = function (o, a, b) {
      return (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);
    };
    var lower = [];
    for (var li = 0; li < pts.length; li += 1) {
      while (lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], pts[li]) <= 0) {
        lower.pop();
      }
      lower.push(pts[li]);
    }
    var upper = [];
    for (var ui = pts.length - 1; ui >= 0; ui -= 1) {
      while (upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], pts[ui]) <= 0) {
        upper.pop();
      }
      upper.push(pts[ui]);
    }
    lower.pop();
    upper.pop();
    var hull = lower.concat(upper);
    if (hull.length >= 3 && this.getPolygonArea(hull) > 0) {
      hull.reverse();
    }
    return hull;
  };

  ScaleBarBuilder.prototype.applyCutInsets = function (vertices, paper, options) {
    if (!vertices.length) {
      return vertices;
    }
    var opts = options || {};
    var printable = this.getPrintableRect(paper, 0);
    var insets = this.sanitizeCutInsets(this.state.cutInsetsMm);
    var bbox = this.getVerticesBbox(vertices);
    var minX = bbox.xMm;
    var maxX = bbox.xMm + bbox.wMm;
    var minY = bbox.yMm;
    var maxY = bbox.yMm + bbox.hMm;
    var adjusted = [];
    for (var i = 0; i < vertices.length; i += 1) {
      var x = vertices[i].x;
      var y = vertices[i].y;
      if (Math.abs(x - minX) < 0.001) {
        x -= insets.left;
      }
      if (Math.abs(x - maxX) < 0.001) {
        x += insets.right;
      }
      if (Math.abs(y - minY) < 0.001) {
        y -= insets.top;
      }
      if (Math.abs(y - maxY) < 0.001) {
        y += insets.bottom;
      }
      adjusted.push({
        x: clamp(x, printable.minX, printable.maxX),
        y: clamp(y, printable.minY, printable.maxY)
      });
    }
    if (opts.preserveAngles) {
      return adjusted;
    }
    return this.simplifyOrthogonalVertices(adjusted);
  };

  ScaleBarBuilder.prototype.finalizeCutShapeVertices = function (vertices, paper, options) {
    var opts = options || {};
    var source = Array.isArray(vertices) ? vertices : [];
    if (!source.length) {
      this.state.cutShape = {
        vertices: [],
        bbox: { xMm: 0, yMm: 0, wMm: 0, hMm: 0 }
      };
      return [];
    }
    var withInsets = this.applyCutInsets(source, paper, { preserveAngles: !!opts.preserveAngles });
    if (!opts.preserveAngles) {
      withInsets = this.simplifyOrthogonalVertices(withInsets);
    }
    if (this.getPolygonArea(withInsets) > 0) {
      withInsets.reverse();
    }
    this.state.cutShape = {
      vertices: withInsets,
      bbox: this.getVerticesBbox(withInsets)
    };
    return withInsets;
  };

  ScaleBarBuilder.prototype.buildCutCircleVertices = function (centerXMm, centerYMm, diameterMm, segments) {
    var out = [];
    var count = Math.max(16, Math.round(parseNumber(segments, 48)));
    var radiusMm = Math.max(1, parseNumber(diameterMm, 20) / 2);
    for (var i = 0; i < count; i += 1) {
      var t = (Math.PI * 2 * i) / count;
      out.push({
        x: centerXMm + Math.cos(t) * radiusMm,
        y: centerYMm + Math.sin(t) * radiusMm
      });
    }
    return out;
  };

  ScaleBarBuilder.prototype.fitCutCircleToRects = function (rects, paper) {
    if (!Array.isArray(rects) || rects.length === 0) {
      return this.sanitizeCutCircle({
        centerXMm: paper.width / 2,
        centerYMm: paper.height / 2,
        diameterMm: Math.min(paper.width, paper.height) * 0.8,
        initialized: true
      });
    }
    var bboxVertices = this.getBoundingRectVerticesFromRects(rects, paper);
    var bbox = this.getVerticesBbox(bboxVertices);
    var centerX = bbox.xMm + bbox.wMm / 2;
    var centerY = bbox.yMm + bbox.hMm / 2;
    var fitDiameter = Math.max(bbox.wMm, bbox.hMm);
    var padMm = this.state.cutMarginCm * MM_PER_CM;
    return this.sanitizeCutCircle({
      centerXMm: centerX,
      centerYMm: centerY,
      diameterMm: fitDiameter + padMm * 2,
      initialized: true
    });
  };

  ScaleBarBuilder.prototype.getAutoCutOutlineVertices = function (points, paper) {
    if (!points || points.length === 0) {
      return [];
    }
    var rects = this.getCutRectangles(points, paper);
    var cutShapeMode = this.sanitizeCutShapeMode(this.state.cutShapeMode);
    this.state.cutShapeMode = cutShapeMode;
    if (cutShapeMode === 'manual') {
      var manual = this.getCutManualState();
      var manualVertices = this.buildCutManualVertices(manual);
      if (!manualVertices.length) {
        this.state.cutShape = {
          vertices: [],
          bbox: { xMm: 0, yMm: 0, wMm: 0, hMm: 0 }
        };
        return [];
      }
      this.state.cutShape = {
        vertices: manualVertices,
        bbox: this.getVerticesBbox(manualVertices)
      };
      return manualVertices;
    }
    if (cutShapeMode === 'circle') {
      this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
      if (!this.state.cutCircle.initialized) {
        this.state.cutCircle = this.fitCutCircleToRects(rects, paper);
      }
      var circleVertices = this.buildCutCircleVertices(
        this.state.cutCircle.centerXMm,
        this.state.cutCircle.centerYMm,
        this.state.cutCircle.diameterMm,
        56
      );
      if (this.getPolygonArea(circleVertices) > 0) {
        circleVertices.reverse();
      }
      this.state.cutShape = {
        vertices: circleVertices,
        bbox: this.getVerticesBbox(circleVertices)
      };
      return circleVertices;
    }
    if (!rects.length) {
      return this.finalizeCutShapeVertices([], paper);
    }
    if (cutShapeMode === 'rectangle' || points.length <= 2) {
      return this.finalizeCutShapeVertices(this.getBoundingRectVerticesFromRects(rects, paper), paper);
    }
    var bridgeRects = this.buildCutBridgeRects(points, paper);
    var allRects = rects.concat(bridgeRects);
    var union = this.buildUnionOutlineFromRects(allRects);
    var conformVertices = union.vertices || [];
    if (!conformVertices.length || union.loopCount > 1) {
      conformVertices = this.getBoundingRectVerticesFromRects(allRects.length ? allRects : rects, paper);
    } else {
      conformVertices = this.simplifyOrthogonalVertices(conformVertices);
    }

    if (cutShapeMode === 'conform') {
      if (this.getConcaveVertexCount(conformVertices) > 1) {
        conformVertices = this.getBoundingRectVerticesFromRects(allRects.length ? allRects : rects, paper);
      }
      return this.finalizeCutShapeVertices(conformVertices, paper);
    }

    var angledVertices = this.getConvexHullVertices(conformVertices);
    if (!angledVertices || angledVertices.length < 3) {
      angledVertices = this.getBoundingRectVerticesFromRects(allRects.length ? allRects : rects, paper);
    }
    return this.finalizeCutShapeVertices(angledVertices, paper, { preserveAngles: true });
  };

  ScaleBarBuilder.prototype.computeWarnings = function (points) {
    var paper = this.getPaper();
    var outOfBounds = [];

    for (var i = 0; i < points.length; i += 1) {
      var p = points[i];
      var half = this.getTagSizeMm(i) / 2;
      var printable = this.getPrintableRect(paper, half);
      if (p.x < printable.minX || p.x > printable.maxX || p.y < printable.minY || p.y > printable.maxY) {
        outOfBounds.push(i + 1);
      }
    }

    return outOfBounds;
  };
})();
